module.exports = __webpack_public_path__ + "static/media/recurring.b97484e4.svg";